import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import DataTable from '../DataTable';
import ConfirmDeleteModal from '../ConfirmDeleteModal';
import SearchQuestion from './SearchQuestion';
import QuestionCategoriesTable from './QuestionCategoriesTable';
import CreateQuestionCategoryModal from './CreateQuestionCategoryModal';
import SearchKeyword from '../keyword/SearchKeyword';

const QuestionCategoriesMain = ({ render, setRender, data, rows, setPassSelectedCategoryId, columns, onAssignToQuestion }) => {
    const [rowsData, setRowsData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('all');
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [delCategoryId, setDelCategoryId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [delData, setDeleteData] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});


    useEffect(() => {
        setRowsData(rows);
        fetchCategories();
        loadColumnVisibility();
    }, [render]);

    useEffect(() => {
        handleCategorySelect(selectedCategoryId);
    }, [render]);

    const handleBulkDelete = async (deleteData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}question/bulk-delete`, { questionIds: deleteData } ,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Selected questions deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error(error.response.data.message || 'Failed to delete selected questions');
        }
    };

    const handleDeleteCategory = async (categoryId) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}question-category/delete/${categoryId}`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Category deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error('Failed to delete category');
        }
    };

    const ConfirmHandleDelete = (deleteData) => {
        setIsDeleteModalOpen(true);
        setDeleteData(deleteData);
    };

    const handleDeleteConfirm = () => {
        setIsDeleteModalOpen(false);
        handleBulkDelete(delData);
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}question-category/all-categories`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setCategories(response.data);
        } catch (error) {
            toast.error('Failed to fetch categories');
        }
    };

    const fetchQuestionsByCategory = async (categoryId, page = 1, limit = 100) => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}question-category/${categoryId}/questions?page=${page}&limit=${limit}`;
            const response = await axios.get(url,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setTotalPages(response.data.totalPages);
            setCurrentPage(response.data.currentPage);
            setTotalItems(response.data.totalItems);

            const flattenQuestions = response.data.questions.map((row) => ({
                id: row._id,
                _id: row._id,
                questionText: row.questionText,
                location: row.location,
                searchKeyword: row.searchKeyword
            }));

            setRowsData(flattenQuestions);
        } catch (error) {
            toast.error('Failed to fetch questions by category');
        }
    };

    const setSearchQuestion = (questionData) => {
        setTotalPages(questionData.totalPages);
        setCurrentPage(questionData.currentPage);
        setTotalItems(questionData.totalItems);

        const flattenQuestions = questionData.questions.map((row) => ({
            id: row._id,
            _id: row._id,
            questionText: row.questionText,
            location: row.location,
            searchKeyword: row.searchKeyword,

        }));

        setRowsData(flattenQuestions);

    }
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchQuestionsByCategory(selectedCategoryId, newPage);
    };

    const handleCategorySelect = (categoryId) => {
        setCurrentPage(1);
        setSelectedCategoryId(categoryId);
        setPassSelectedCategoryId(categoryId);
        fetchQuestionsByCategory(categoryId, 1);
    };

    const loadColumnVisibility = () => {
        const storedVisibility = localStorage.getItem('questionColumnVisibility');
        if (storedVisibility) {
            setColumnVisibilityModel(JSON.parse(storedVisibility));
        }
    };

    const saveColumnVisibility = (model) => {
        localStorage.setItem('questionColumnVisibility', JSON.stringify(model));
        setColumnVisibilityModel(model);
    };

    return (
        <div>
            <SearchQuestion setSearchQuestion={setSearchQuestion} />
            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                <div style={{ flex: 2, marginRight: "20px" }}>
                    <QuestionCategoriesTable onCategorySelect={handleCategorySelect} categories={categories} handleDeleteCategory={handleDeleteCategory} />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            style={{ width: "130px", height: "50px", padding: "10px", marginTop: "15px", backgroundColor: '#1B3C73', color: "white" }}
                            variant="outlined"
                            size="small"
                            onClick={() => setIsCreateModalOpen(true)}
                        >
                            Category
                        </Button>
                    </div>
                </div>
                <div style={{ flex: 10 }}>
                    {data.length > 0 && rowsData.length > 0 ? (
                        <DataTable rows={rowsData} columns={columns} onDeleteSelected={ConfirmHandleDelete} onAssignToQuestion={onAssignToQuestion} handlePageChange={handlePageChange} currentPage={currentPage} totalPages={totalPages} totalItems={totalItems} saveColumnVisibility={saveColumnVisibility} columnVisibilityModel={columnVisibilityModel} />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <CreateQuestionCategoryModal
                open={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                fetchCategories={fetchCategories}
            />
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <ConfirmDeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
                message="Are you sure you want to delete this question?"
            />
        </div>
    );
};

export default QuestionCategoriesMain;

